<template>
  <div
    class="pb-3"
  >{{ $t('Процедура будет признана несостоявшейся, т.к. Вы не выбрали победителя. Укажите, пожалуйста, причину отсутствия победителя.') }}</div>
  <div v-if="!reasons.length">{{ $t('Загрузка списка причин...') }}</div>
  <template v-for="(reason) in reasons" :key="reason.id">
    <v-checkbox-btn
      :label="reason.description"
      :value="reason.id"
      v-model="selected"
      true-icon="custom:checkboxOutline"
      false-icon="custom:checkboxBlankOutline"
      color="primary"
      class="pb-3"
    />
  </template>
  <v-textarea
    :rows="3"
    maxlength="255"
    variant="outlined"
    v-if="selected.find((id) => id === otherReasonId) !== undefined"
    v-model="otherReasonExplanation"
    hide-details
    :placeholder="$t('Укажите причину отсутствия победителя')"
  />
</template>

<script setup lang="ts">
import { computed, onMounted, ref, watch } from 'vue';
import api from '@/api';
import { toast } from '@/lib/toast';

const OTHER_REASON_CODE = 'other';

interface Reason {
  id: number;
  code: string;
  orderNumber: number;
  description: string;
}

const props = defineProps({
  reasons: Array<{
    id: number,
    explanation?: string,
  }>,
  isValid: Boolean,
});

const emit = defineEmits(['update:reasons', 'update:isValid']);

const reasons = ref<Reason[]>([]);

const otherReasonId = computed(
    () => reasons.value.find((reason: Reason) => reason.code === OTHER_REASON_CODE)?.id
);

const updateReasons = (reasons: Array<number>, otherReason?: string) => {
  emit(
    'update:reasons',
    reasons.map(id => {
      return {
        id,
        explanation: id === otherReasonId.value && otherReason ? otherReason : null,
      };
    }),
  );
};

const selected = computed({
  get: () => props.reasons.map(reason => reason.id),
  set: (newValue) => updateReasons(newValue, otherReasonExplanation.value),
});
const otherReasonExplanation = computed({
  get: () => props.reasons.find(reason => reason.id === otherReasonId.value)?.explanation ?? '',
  set: (newValue) => updateReasons(selected.value, newValue),
});

watch(
  () => reasons.value.length > 0 && selected.value.length > 0
    && (!selected.value.includes(otherReasonId.value) || otherReasonExplanation.value.trim().length > 0),
  (value) => emit('update:isValid', value)
);

onMounted(async () => {
  try {
    reasons.value = await api.get(`/vocab/procedure-cancellation-reasons`);
  } catch (e) {
    toast.error(e.message);
  }
});
</script>

<style scoped>
* {
  font-weight: 500;
}

.v-selection-control {
  --v-selection-control-size: auto;
}

:deep(label) {
  margin-left: 10px;
}

textarea {
  padding: 10px 12px;
}
</style>
